import * as React from 'react';

import HeaderLogin from '../header-login';
import { ILoginSession } from 'types/session';
import AnalyticsService from 'modules/analytics-provider/analytics-provider.service';

import { HEADER_ANALYTICS_ATTRIBUTES } from './header.constants';

import './header.styles.less';
import IConfig from '@sitegen/common/constants/config';

export interface IHeaderProps {
    config: IConfig;
    language: string;
    loginSession: ILoginSession;
    logIn?: () => void;
    logOut?: () => void;
}

export const Header = (): JSX.Element => {
    const handleClick = (): void => {
        AnalyticsService.sendClickEvent(HEADER_ANALYTICS_ATTRIBUTES);
    };

    return (
        <div className="sitegen-header">
            <div className="sitegen-header__logo-container">
                <a href="https://www.ubisoft.com"
                    target="_blank"
                    rel="noreferrer"
                    className="sitegen-header__logo"
                    onClick={handleClick}
                />
            </div>
            <HeaderLogin />
        </div>
    );
};

export default Header;
